import { Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { If } from 'app/components';
import { Formatters } from 'app/utils/formatters';
import { fetchHealthData, selectLatestDataDate } from 'features/tools/slice';

export const LatestDataDate: React.FunctionComponent = () => {
    const minDate = useSelector(selectLatestDataDate);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchHealthData());
    }, [dispatch]);

    return (
        <If condition={'' !== minDate}>
            <Typography>Data Date: {Formatters.date(minDate)}</Typography>
        </If>
    );
};
